import PropTypes from 'prop-types';
import { useNavigate } from "react-router-dom";

import Container from '@mui/material/Container';
import Stack from "@mui/material/Stack";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PasswordIcon from '@mui/icons-material/Password';

import MenuWidget from "../common/MenuWidget";
import './ProviderSettingsMenu.scss';

const ProviderSettingsMenu = () => {
  const navigate = useNavigate();
  const summaryStats = [
    {
      title: 'Account Info',
      Icon: AccountBoxIcon,
      onClick: () => navigate('/providers/settings/account'),
    },
    {
      title: 'Profile',
      Icon: AccountCircleIcon,
      onClick: () => navigate('/providers/settings/profile'),
    },
    {
      title: 'Reset Password',
      Icon: PasswordIcon,
      onClick: () => navigate('/reset-password/start'),
    }
  ];
  return (
    <Container className='ProviderSettingsMenu' maxWidth='xl'>
      <Stack direction='row' spacing={{ xs: 2, lg: 4 }} useFlexGap flexWrap='wrap' justifyContent='center'>
        {
          summaryStats.map(s =>
            <MenuWidget className="ProviderSettingsMenu__menu" {...s} />
          )
        }
      </Stack>
    </Container>
  );
};

ProviderSettingsMenu.propTypes = {
  providerId: PropTypes.string,
  logout: PropTypes.func,
};

export default ProviderSettingsMenu;
